import Share from 'components/Dashboard/components/Share';
import { dataHubUsers } from 'components/Dashboard/SidebarElements/parliamentarianUsers';
import preventLink from 'components/Dashboard/TagsList/prevenLink';
import { store } from 'components/Store';
import { useContext, useRef } from 'react';

const GeneralItemActions = (props) => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { selectedUpdatesIds, selectedUpdates, activePlan } = state;
  const { item, index, influenceItem, thumbDownProps, itemActionsProps, itemId } = props;
  const { onlyDots, noAddToReportButton, noCheckbox } = itemActionsProps ?? {};
  const dataHubUser = dataHubUsers(activePlan);

  const changeFunction = (e) => {
    e.stopPropagation();
    e.preventDefault();

    let newSelectedUpdates = [...selectedUpdates];
    let newSelectedUpdatesIds = [...selectedUpdatesIds];

    if (newSelectedUpdatesIds?.includes(id)) {
      const position = selectedUpdatesIds?.indexOf(id);
      if (position >= 0) {
        newSelectedUpdates?.splice(position, 1);
        newSelectedUpdatesIds.splice(position, 1);
      }
    } else {
      newSelectedUpdates = [...newSelectedUpdates, item];
      newSelectedUpdatesIds = [...newSelectedUpdatesIds, id];
    }
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'selectedUpdatesIds',
      value: newSelectedUpdatesIds,
    });
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'selectedUpdates',
      value: newSelectedUpdates,
    });
  };

  const buttonElement = useRef(null);
  const id = itemId ?? item?.id;

  return (
    <>
      {!onlyDots && !noAddToReportButton && (
        <button
          className='d-none d-lg-flex button-create-report circle-button-30  general-button light-50-text flex-centered justify-content-center'
          data-tooltip-content={
            item?.embargoed ? 'You cannot add this update to a report while it is under embargo' : `Add to a report`
          }
          ref={buttonElement}
          data-tooltip-id='general-tooltip'
          onClick={(e) => {
            buttonElement?.current?.blur();
            preventLink(e);
            if (!dataHubUser) {
              dispatch({
                type: 'MODIFY_SECTION',
                parameter: 'createReportFromUpdatePopup',
                value: {
                  open: true,
                  update: item,
                },
              });
            }
          }}
          disabled={item?.embargoed}
        >
          <span className='icon-document' />
        </button>
      )}

      <Share
        item={item}
        listItem={true}
        influenceItem={influenceItem}
        index={index}
        itemActionsProps={itemActionsProps}
        thumbDownProps={thumbDownProps}
      />
      {item?.type === 'Tweet' && <span className='icon-twitter-x title-h3 mr-2 specific-top-padding-1'></span>}
      {!noCheckbox && (
        <div
          className='specific-right-padding-16 specific-left-margin-2 general-item-actions-box'
          onClick={(e) => {
            e.stopPropagation();
            changeFunction(e);
          }}
        >
          <div className='border-left specific-left-padding-12 text-main-blue'>
            <div className={`crm-table-item-checkbox`}>
              <input onChange={(e) => {}} type={'checkbox'} checked={selectedUpdatesIds?.includes(id)} />
              <label htmlFor={`crmContact-${id}`} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GeneralItemActions;
